import { memo } from 'react';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import _map from 'lodash/map';
// Local files
import { Root } from './List.styled';
import Item from './Item/Item';
import ListSkeleton from 'components/Common/Feedback/ListSkeleton/ListSkeleton';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useCustomSelector from 'hooks/useCustomSelector';
import { sixthFlowsSelectors } from 'features/sixthFlows';

const SixthFlowPromptsList = () => {
  const { sixth_prompts } = useCustomSelector(sixthFlowsSelectors.getSixthFlowData);
  const fetching = useCustomSelector(sixthFlowsSelectors.sixthFlowIsFetching);

  return (
    <Root>
      {fetching ? <ListSkeleton /> : <List sx={{ flexGrow: 1, overflow: 'auto' }}>
        {_map(sixth_prompts, (s) => <Item key={s.id} {...s} />)}
        {sixth_prompts.length === 0 && !fetching && <Typography sx={{ textTransform: 'uppercase', textAlign: 'center' }}>No prompts</Typography>}
      </List>}
    </Root>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SixthFlowPromptsList {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);